// Registri da compilare — hub (T-248).
// Raccoglie i registri del Manuale HACCP che si compilano a mano in app
// (non alimentati dal flusso operativo quotidiano). Raggiungibile dal tile
// "Registri da compilare" della dashboard.

import {
  IonBackButton, IonButtons, IonContent, IonHeader, IonIcon, IonNote,
  IonPage, IonTitle, IonToolbar,
} from '@ionic/react';
import { chevronForward, lockClosedOutline } from 'ionicons/icons';
import { useIonRouter } from '@ionic/react';

interface CompilaItem {
  mod: string;
  icon: string;
  title: string;
  hint: string;
  route: string | null; // null = ancora senza scheda di inserimento
  note?: string;
}

const ITEMS: CompilaItem[] = [
  { mod: 'Olio', icon: '🧪', title: 'Controllo olio', hint: 'Verifiche olio e sostituzioni', route: '/haccp/oil-control' },
  { mod: 'Acrilammide', icon: '🍞', title: 'Controllo acrilammide', hint: 'Cottura e confronto cromatico', route: '/haccp/acrylamide-control' },
  { mod: '03', icon: '⚠️', title: 'Non conformità', hint: 'Non conformità rilevate + azioni correttive', route: '/haccp/non-conformita' },
  { mod: '05', icon: '🎓', title: 'Formazione personale', hint: 'Personale e attestati HACCP (titolo, ente, scadenza)', route: '/haccp/formazione', note: 'Stessi dati del Manuale (Profilo locale)' },
  { mod: '06', icon: '🛠️', title: 'Manutenzione attrezzature', hint: 'Interventi ordinari/straordinari sulle attrezzature', route: '/haccp/manutenzione' },
  { mod: '07', icon: '🔧', title: 'Taratura strumenti', hint: 'Tarature di termometri, sonde, bilance + scadenze', route: '/haccp/calibrations' },
  { mod: '10', icon: '🚚', title: 'Temperature trasporto', hint: 'Temperatura partenza/arrivo dei trasporti', route: '/haccp/trasporto' },
  { mod: '11', icon: '🐀', title: 'Pest control', hint: 'Interventi e monitoraggi infestanti + scadenze', route: '/haccp/pest-control' },
];

export function RegistriCompilaPage(): JSX.Element {
  const router = useIonRouter();
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start"><IonBackButton defaultHref="/today" /></IonButtons>
          <IonTitle>Registri da compilare</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <p style={{ fontSize: 13, color: '#64748b', marginTop: 0 }}>
          Registri del Manuale HACCP che si compilano a mano in app. Gli altri (temperature,
          pulizie, carico, etichette, abbattimento) si riempiono già dai flussi quotidiani.
          L'export A4 di tutti è in <b>Export registri</b>.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {ITEMS.map((it) => {
            const enabled = !!it.route;
            return (
              <button
                key={it.mod}
                type="button"
                disabled={!enabled}
                onClick={() => { if (it.route) router.push(it.route); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left',
                  padding: '12px 14px', borderRadius: 12, border: '1px solid #e2e8f0',
                  background: enabled ? '#fff' : '#f8fafc', cursor: enabled ? 'pointer' : 'default',
                  opacity: enabled ? 1 : 0.7,
                }}
              >
                <span style={{ fontSize: 24, flexShrink: 0 }}>{it.icon}</span>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#0f172a' }}>
                    MOD. {it.mod} — {it.title}
                  </div>
                  <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{it.hint}</div>
                  {it.note && <IonNote style={{ fontSize: 11 }}>{it.note}</IonNote>}
                </div>
                <IonIcon icon={enabled ? chevronForward : lockClosedOutline} style={{ fontSize: 18, color: '#94a3b8', flexShrink: 0 }} />
              </button>
            );
          })}
        </div>
      </IonContent>
    </IonPage>
  );
}
